import { ServerService } from './../../shared/services/server.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-videoinstruction',
	templateUrl: './videoinstruction.component.html',
	styleUrls: [ './videoinstruction.component.scss' ]
})
export class VideoinstructionComponent implements OnInit {
	public api = environment.apiUrl;
	intructions: VideoInstruct[] = [];
	videoModal: boolean = false;
	videoSrc: string;
	videoId: number;
	constructor(private server: ServerService) {}

	ngOnInit() {
		this.server.getVideoInstructionName().then((res) => {
			this.intructions = res;
		});
  }
  videoTitle: string = '';
	showVideo(instruction) {
    this.videoId = instruction.id;
    this.videoTitle = instruction.title;
		this.videoModal = true;
		this.server.showVideo(instruction.id).then((res) => {
    });
	}

}

export interface VideoInstruct {
	id: number;
	title: string;
}
